/* Office Walker 2A — click-to-play clips (M4) and clickable anatomy markers (S7). */
(function () {
  'use strict';

  // M4 / any click-to-play video: poster thumbnail, plays on click, no autoplay.
  document.querySelectorAll('[data-ow2-clip]').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var btn = wrap.querySelector('[data-clip-play]');
    if (!video) return;
    function play() {
      video.play();
      wrap.classList.add('is-playing');
      video.setAttribute('controls', 'controls');
    }
    if (btn) btn.addEventListener('click', play);
    video.addEventListener('play', function () { wrap.classList.add('is-playing'); });
    video.addEventListener('pause', function () { if (video.currentTime === 0) wrap.classList.remove('is-playing'); });
  });

  // S7 anatomy: clicking a marker highlights it and its legend row.
  document.querySelectorAll('[data-ow2-anatomy]').forEach(function (root) {
    var markers = root.querySelectorAll('[data-marker]');
    var rows = root.querySelectorAll('[data-legend]');
    function select(n) {
      markers.forEach(function (m) { m.classList.toggle('is-on', m.getAttribute('data-marker') === n); });
      rows.forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-legend') === n); });
    }
    markers.forEach(function (m) {
      m.addEventListener('click', function () { select(m.getAttribute('data-marker')); });
    });
    rows.forEach(function (r) {
      r.addEventListener('click', function () { select(r.getAttribute('data-legend')); });
    });
    // start with the first marker active
    if (markers[0]) select(markers[0].getAttribute('data-marker'));
  });
})();
